import { useEffect, useState } from "react";
import Select, { components } from "react-select";

import { useAxios } from "../../../../hooks";

export default function Categorize({ categorize, setCategorize, setPage }) {
  const axios = useAxios();
  const [options, setOptions] = useState([
    { label: "Select Partner", value: "PLACEHOLDER", isDisabled: true },
    { label: "All", value: "ALL" },
  ]);

  useEffect(() => {
    axios({
      url: "/list/dynamicDashboard",
      disableError: true,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        for (let tenants of response.data) {
          setOptions((prev) => [
            ...prev,
            { label: tenants.platform_name, value: tenants.platform_id },
          ]);
        }
      }
    });
  }, [axios]);

  const selectedOption = options.find(
    (opt) => opt.value === parseInt(categorize)
  );

  const styles = {
    control: (base, state) => ({
      ...base,
      display: "flex",
      width: "fit-content",
      minHeight: "50px",
      height: "50px",
      padding: "0 18px",
      alignItems: "center",
      borderRadius: "15px",
      boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
      border: "none",
      backgroundColor: "#fff",
      justifyContent: "space-between",
      transition: "border 0.2s ease-in-out",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: 0,
      ...base,
      display: "flex",
      alignItems: "center",
      paddingLeft: "0px",
    }),
    singleValue: (base) => ({
      ...base,
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px",
      color: "#000000",
      mixBlendMode: "normal",
      opacity: 0.4,
    }),
    placeholder: (base) => ({
      ...base,
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px",
      color: "#000000",
      mixBlendMode: "normal",
      opacity: 0.4,
    }),
    option: (base, { isSelected, isFocused, isDisabled }) => ({
      ...base,
      backgroundColor: isFocused ? "#f5f5f5" : "white",
      color: isDisabled ? "#9e9e9e" : "#212121",
      fontWeight: isSelected ? 600 : 400,
      fontSize: "14px",
      padding: "10px 15px",
      cursor: isDisabled ? "not-allowed" : "pointer",
      opacity: isDisabled ? 0.6 : 1,
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
      overflow: "hidden",
      zIndex: 20,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "rgba(128, 128, 128, 0.7)",
      paddingRight: "8px",
    }),
    indicatorSeparator: () => null,
  };

  const handleTypeSelect = (e) => {
    setCategorize(e.value);
    setPage((prev) => ({
      ...prev,
      page: 1,
    }));
  };

  return (
    <Select
      styles={styles}
      options={options}
      onChange={handleTypeSelect}
      isSearchable={false}
      placeholder="Partners"
      components={{
        IndicatorSeparator: () => null,
        ValueContainer: (props) => (
          <components.ValueContainer {...props}>
            <span
              style={{
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "20px",
                color: "#000000",
                mixBlendMode: "normal",
                opacity: 0.4,
              }}
            >
              Partners: &nbsp;
            </span>
            {props.children}
          </components.ValueContainer>
        ),
      }}
      value={selectedOption}
    />
  );
}
